import { render, staticRenderFns } from "./ShowChallenge.vue?vue&type=template&id=46ebd7c0"
import script from "./ShowChallenge.vue?vue&type=script&lang=js"
export * from "./ShowChallenge.vue?vue&type=script&lang=js"
import style0 from "./ShowChallenge.vue?vue&type=style&index=0&id=46ebd7c0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports